import React, { useState } from 'react';
import Navbar from '../../containers/Navbar/Navbar';
import {useDispatch} from 'react-redux';
import {loginUser} from '../../../redux/actions/authActions';
import CircularSpinner from '../../utils/CircularSpinner';
import style from './Login.module.css';
import { Link, useHistory } from 'react-router-dom';

const Login = () => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [isLoginLoading, setIsLoginLoading] = useState(false);
    const [error, setError] = useState("");
    const dispatch = useDispatch();
    const history = useHistory();

    const loginSubmit = async (e) => {
        e.preventDefault();
        setIsLoginLoading(true);
        const data = {
            email,
            password
        }
        const response = await dispatch(loginUser(data))
        if(response && response?.status === 200){
            history.push("/");
        }else{
            const errorMessage = response?.data?.errorMessage || "Something went wrong";
            setError(errorMessage);
            setIsLoginLoading(false);
        }
    }

    return (
        <div className={style.loginContainer}>
           <div className="container">
            <Navbar />
            <div className={`${style.loginForm}`}>
                <h3 className='text-center'> Login Form </h3>
                { error ? 
                    <div className="alert alert-danger alert-dismissible fade show" role="alert">
                        {error}
                        <button type="button" onClick = {() => setError("")} className="btn-close" data-bs-dismiss="alert" aria-label="Close">
                        </button>
                    </div>
                    :  <></>
                }
                <form onSubmit={loginSubmit}>
                    <div className='form-group mt-5'>
                        <input className="form-control w-100" 
                        type='email' 
                        placeholder="Enter your email id"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)} />
                    </div>
                    <div className='form-group mt-5'>
                        <input className="form-control w-100"
                        type='password' 
                        value={password}
                        placeholder="Enter your password"
                        
                        onChange={(e) => setPassword(e.target.value)} />
                    </div>
                    <div className='form-group mt-5 d-flex justify-content-end'>
                        <span>
                            <Link to="/forgot-password">
                                Forgot Password ?
                            </Link>
                        </span>
                    </div>
                    <div className='form-group mt-5'>
                        <button className='btn btn-primary w-100' disabled={isLoginLoading}>
                            {
                                isLoginLoading ?
                                <CircularSpinner /> :
                                <div>Login</div>
                            }
                        </button>
                    </div>
                </form>
            </div>
           </div>
        </div>
    )
}

export default Login
